import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './TableHead.module.scss';
import Paragraph from '../../../../components/Typography/Paragraph/Paragraph';
import cn from 'classnames';
const TableHead = ({ columns, className, columnStart }) => {
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [columnStart && _jsx(Paragraph, { title: '' }), columns.map(({ label, accessor }) => {
                return (_jsx(Paragraph, { fontFamily: 'urbanist', size: 1, color: 'grey', title: label.toLocaleUpperCase() }, accessor));
            })] })));
};
export default TableHead;
